import { render, staticRenderFns } from "./TecInfoNCS.vue?vue&type=template&id=982451c8&"
import script from "./TecInfoNCS.vue?vue&type=script&lang=js&"
export * from "./TecInfoNCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports